import PersonalInfoComponent from './PersonalInfoContainer';

export default PersonalInfoComponent;
